<template>
  <div v-if="renderReady && !model.$disabled && showLabel">
    <label :for="labelFor" class="label" v-if="show || onlyDescription">
      <template v-if="show && !onlyDescription">
        <w-next-number v-bind="nextNumber" v-if="nextNumber" />

        <span :class="boldLabel ? 'text-bold' : ''">
          <slot>{{ getTitle }}</slot>
        </span>
      </template>

      <w-tooltip v-if="show && !onlyDescription && tooltipContent && tooltipContent.length">{{ tooltipContent }}</w-tooltip>

      <w-description v-if="show || onlyDescription" :model="model" :description="newDesc" :only-description="onlyDescription">
        <slot name="description" />
      </w-description>
    </label>

    <slot name="afterLabel" />
  </div>
</template>

<script>
import modelMixin from '../mixins/modelMixin';
import titleMixin from '../mixins/titleMixin';
import WTooltip from './tooltip.vue';

export default {
  name: 'w-label',
  components: {WTooltip},
  props: {
    css: [Object, String, Array]
  },
  mixins: [modelMixin, titleMixin],
  computed: {
    show() {
      return this.isTitle || this.hasDefaultSlot;
    },
    hasDefaultSlot() {
      return !!(this.$slots && this.$slots.default);
    },
    newDesc() {
      return Object.assign(this.description, {newLine: this.show && !this.onlyDescription});
    }
  }
};
</script>

<style scoped>
.smart-form label.label {
  display: inline-block;
}
</style>
